// @flow

import React from 'react';
import {graphql, QueryRenderer} from 'react-relay';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import modernEnvironment from '../lib/RelayUtils';

type PropsType = {
    value: string,
    onChange: (string) => void
}

const SectionSelector = (props: PropsType) => 
    <QueryRenderer
        environment={modernEnvironment}
        variables={{}}
        query={graphql`
            query SectionSelector_Query {
                viewer {
                    sections {
                        edges {
                            node { 
                                id 
                                name
                            }
                        }
                    }
                }
            }

        `}
        render={ res => {            
            const qProps = res.props;
            const qError = res.error;

            if (qError) {
                return <div>Ошибка загрузки</div>;
            }

            if (!qProps) {
                return <div/>;
            }

            return (
                <SelectField 
                    floatingLabelText="Раздел" 
                    value={props.value}
                    onChange={(event, index, value) => {
                        if (props.onChange) {
                            props.onChange(value)
                        }
                    }}
                >
                    {qProps.viewer.sections.edges.map(e => e.node).filter(s => (s.name === 'Новости 78' || s.name === 'Статьи')).map((e, i) =>
                        <MenuItem 
                            key={i} 
                            value={e.id} 
                            primaryText={e.name}
                        />)}
                </SelectField>)
        }
        }/>

export default SectionSelector;


// WEBPACK FOOTER //
// src/components/SectionSelector.js